// API Configuration
// Uses environment variable in production, localhost in development

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Get current Firebase user and token with automatic refresh
const getAuthToken = async (forceRefresh = false) => {
  try {
    const { auth } = await import('./firebase');
    const user = auth.currentUser;
    if (user) {
      // getIdToken() automatically refreshes if token is expired or close to expiring
      // forceRefresh=true will always get a fresh token
      return await user.getIdToken(forceRefresh);
    }
  } catch (error) {
    console.error('Error getting auth token:', error);
  }
  return null;
};

// Fetch wrapper that includes Firebase auth token and corpus ID
export const fetchWithCredentials = async (url, options = {}) => {
  try {
    // Get fresh token (Firebase auto-refreshes if needed)
    const token = await getAuthToken();
    
    // Get corpus ID from localStorage (set on login)
    const corpusId = localStorage.getItem('corpus_id');
    
    const response = await fetch(url, {
      ...options,
      credentials: 'include',
      headers: {
        ...options.headers,
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...(corpusId ? { 'X-Corpus-ID': corpusId } : {})
      }
    });
    
    // If we get a 401 (token expired/invalid), try once more with force refresh
    if (response.status === 401) {
      console.log('Token expired, forcing refresh...');
      const freshToken = await getAuthToken(true); // Force refresh
      
      if (freshToken) {
        // Retry request with fresh token
        return fetch(url, {
          ...options,
          credentials: 'include',
          headers: {
            ...options.headers,
            'Authorization': `Bearer ${freshToken}`,
            ...(corpusId ? { 'X-Corpus-ID': corpusId } : {})
          }
        });
      }
    }
    
    return response;
  } catch (error) {
    console.error('Error in fetchWithCredentials:', error);
    throw error;
  }
};

export default {
  API_URL,
  fetchWithCredentials
};

